module.exports = __webpack_public_path__ + "img/foot_bg.df4e8bad.png";